<ng-template uiProductPriceVisibility [prices]="prices()">
  <div class="wrapper-prices">
    <span class="label">Einzelpreis:</span>
    <div class="current-price">
      <ui-product-prices
        [productPrice]="prices()"
        [showThousandthsPlace]="true"
      ></ui-product-prices>

      @if (depositPrice() && this.prices().salesUnitDeposit) {
        <div class="deposit">
          <span>Pfand je VE (zzgl.)</span>
          <ui-product-prices-default
            class="text-small"
            [price]="depositPrice()"
            [showThousandthsPlace]="true">
          </ui-product-prices-default>
        </div>
      }
    </div>

    <span class="label"></span>
    <span class="original-price"></span>
    <span class="current-price"></span>

    @if (prices().salesUnit; as regularSalesUnitPrice) {
      <span class="label">Preis je VE</span>
      <span class="original-price"></span>
      <ui-product-prices-formatter
        class="current-price"
        [price]="regularSalesUnitPrice"
        [showThousandthsPlace]="true"
      ></ui-product-prices-formatter>
    }

    <span class="label">{{ prices().endUserPriceLabel }}</span>
    <span class="original-price"></span>
    @if (prices().endUser; as endUserPrice) {
      <ui-product-prices-formatter
        class="current-price"
        [price]="endUserPrice!"
        [showThousandthsPlace]="true"
      ></ui-product-prices-formatter>
    } @else {
      <span class="empty-end-user-price">k. A.</span>
    }
  </div>

  <hr>
</ng-template>
